import defaultValues from '@/app/features/reports/types/form-default-values';
import { TestSuite } from 'store/src/lib/tests/entity';
import convertInspectionToFormValues from './convertInspectionToFormValues';
import filterActiveCustomFields from './filterActiveCustomFields';
import getTestSuiteForSpecification from './getTestSpecification';
import { isSubmissionReadyForStatus } from './testFormValidator';
import { ReportTestItem } from './entities';

// Would this test pass the suite's required-field validation if it moved to `targetStatus`?
// `useValidationResults` (hence `hasMissingData`) validates against the test's *live* status and
// relaxes required fields while it is a draft, so a Draft test reads as "no missing data" even with
// empty required fields. Anything gating a transition to QA/Final must ask this instead.
// A test whose suite can't be found can't be verified, so it is reported as not ready.
const isTestReadyForStatus = (
  testCase: ReportTestItem,
  testSuites: TestSuite[],
  targetStatus: string
): Promise<boolean> => {
  const found = getTestSuiteForSpecification(testSuites, testCase.test);
  if (!found) return Promise.resolve(false);

  const values = filterActiveCustomFields(convertInspectionToFormValues(testCase), found.suite);
  return isSubmissionReadyForStatus({ ...defaultValues, ...values } as any, testSuites as any, targetStatus);
};

export default isTestReadyForStatus;
